import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/button";

const LandingNav = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <nav className="fixed left-0 right-0 top-0 z-50 bg-white/95 backdrop-blur-sm">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          <Link to="/landing" className="group">
            <span className="relative text-2xl font-bold tracking-tight text-black">
              Bite{" "}
              <span className="relative inline-block">
                Balance
                <span className="absolute -bottom-1 left-0 h-0.5 w-0 bg-green-500 transition-all duration-300 ease-out group-hover:w-full" />
              </span>
              <span className="absolute -right-4 -top-1 h-2 w-2 rounded-full bg-green-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
            </span>
          </Link>
          <div className="hidden items-center gap-10 md:flex">
            <button
              onClick={() => scrollToSection("features")}
              className="font-medium text-black transition-opacity hover:opacity-70"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection("integrations")}
              className="font-medium text-black transition-opacity hover:opacity-70"
            >
              Integrations
            </button>
            <button
              onClick={() => scrollToSection("pricing")}
              className="font-medium text-black transition-opacity hover:opacity-70"
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection("about")}
              className="font-medium text-black transition-opacity hover:opacity-70"
            >
              About
            </button>
          </div>
          <Button
            onClick={() => {
              const el = document.getElementById("about");
              el?.scrollIntoView({ behavior: "smooth" });
            }}
            className="rounded-full bg-black px-6 font-medium text-white hover:bg-black/90"
          >
            Get in Touch
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default LandingNav;
